import HighchartsCore from 'highcharts'

function createGradient(color) {
  return {
    finGradient: color,
    linearGradient: {
      x1: 0,
      y1: 0,
      x2: 0,
      y2: 1
    },
    stops: [
      [0, HighchartsCore.color(color).setOpacity(0.4).get()],
      [1, HighchartsCore.color(color).setOpacity(0.0).get()]
    ]
  }
}

function createFillColor(series, negative, data) {
  const colorType = negative ? 'negativeColor' : 'color'
  const fillColorType = negative ? 'negativeFillColor' : 'fillColor'
  const {type} = series.options
  const fillColor = series.options[fillColorType]
  const color = series[colorType] || series.userOptions[colorType]

  if (type !== 'area'
    || !color
    || (
      fillColor
      && (!fillColor.finGradient || fillColor.finGradient === color)
    )
  ) {
    return
  }
  data[fillColorType] = createGradient(color)
}

const updateGradient = function (chart) {
  chart.series.forEach(series => {

    const data = {}
    createFillColor(series, false, data)
    createFillColor(series, true, data)
    if (Object.keys(data).length !== 0) {
      series.update(data)
    }

  })
}

export default function (H) {

  H.addEvent(H.Chart, 'load', function (e) {
    const chart = e.target
    H.addEvent(chart.xAxis[0], 'afterSetExtremes', function (e) {
      updateGradient(chart)
    })
  })

  H.addEvent(H.Chart, 'render', function (e) {
    const chart = e.target
    updateGradient(chart)
  })
}
